import styled from "styled-components";
import { Calendar } from "react-vant";
import { useState,useRef, useEffect } from "react";
import { getDay,hideAccount } from "../../../utils/utils";
import { FormattedMessage, useIntl } from "react-intl";
import ScrollList from "./ScrollList";
import useWallet from "../../../hooks/Wallet/useWallet";
import useCommon from "../../../hooks/Common/useCommon";
import copy from "copy-to-clipboard";
import {Toast} from 'antd-mobile'
import { getHistory } from "../../../api";
import moment from "moment";
export default function Record1() {
  const intl = useIntl();
  const { lang } = useCommon();
  const { myAccount } = useWallet();
  const now = Date.now();
  const ref1 = useRef()
  const endDate = getDay(now, 0);
  const startDate = getDay(now, -60);
  const rangeDateRef = useRef([new Date(startDate), new Date(endDate)]);


  const loadData = async (page) => {
    const histroies = await getHistory({
      addr: myAccount.account,
      begin: new Date(rangeDateRef.current[0]).getTime() /1000,
      end:new Date(moment(rangeDateRef.current[1]).format('YYYY/MM/DD 23:59:59')).getTime() /1000,
      page:page,
      lang: lang === "en" ? "en" : "cn"
    }); 
    return histroies.data.list
  };
  const clearData = async () => {
    if(ref1.current) {
      ref1.current.clearData()
      ref1.current.refrushData()
    }
  }
    
  return (
    <Wrapper>
      <Col>
        <div className="t"><FormattedMessage id="链上记录" /></div>
        <Calendar
          type="range"
          minDate={new Date(2020, 0, 1)}
          maxDate={new Date()}
          value={rangeDateRef.current}
          onConfirm={(data) => {
            clearData()
            rangeDateRef.current = [data[0], data[1]];
          }}
        >
          {(val, actions) => (
            <Text onClick={() => actions.open()}>
              {val
                ? val.map((el) => moment(el).format('MM/DD')).join(" - ")
                : intl.formatMessage({
                    id: "pages.account.profit_select_date",
                    defaultMessage: "请选择日期",
                  })}
            </Text>
          )}
        </Calendar>
      </Col>
      {myAccount ? <ListWrapper>
          <ScrollList
            ref={ref1}
            getData={loadData}
            content={
              (e, key) => <div key={key} className="item">
              <div className="left">
                {/* e.tx_method === 'transfer' ? "image/icons/icon12.png": */}
                <img src={ e.value < 0 ? "image/icons/icon13.png" :"image/icons/icon14.png"} alt="" />
              </div>
              <div className="content">
                <div className="row" style={{ marginBottom: "1.4rem" }}>
                  <div className="hash">
                    <span>{hideAccount(e.tx_hash,9,6)}</span>{" "}
                    <img src="image/icons/icon15.png" alt="" onClick={() => {
                      copy(e.tx_hash);
                      Toast.show({
                        content: intl.formatMessage({
                          id: "pages.inviter.copied",
                          defaultMessage: "復製成功！",
                        }),
                        icon: "success",
                      });
                    }}/>
                  </div>
                      
                  <div className="value" style={{color: e.value > 0 ? '':'#82D418'}}>{ e.value > 0 ? '+':''}{e.value} {e.currency===1 ? 'RT' : 'RBET'}</div>
                </div>
                <div className="row">
                  <div>
                    <span className="type"><FormattedMessage id="类型" /> </span>
                    <span className="text">{e.tx_method}</span>
                  </div>
                  <div className="text">{ moment(e.create_time).format('YYYY/MM/DD HH:mm')}</div>
                </div>
              </div>
            </div>
            }
            />
      </ListWrapper> :null}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 2.0rem;
`;

const Col = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.0rem;
  .t {
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.8rem;
    color: #000000;
  }
`;

const Text = styled.div`
  background: #39ada4;
  border: 1px solid #ffffff;
  border-radius: .6rem;
  padding: 4px .7rem;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.4rem;
  color: #fff;
`;

const ListWrapper = styled.div`
  background-color: #fff;
  margin-top: 1.2rem;
  border-radius: 1.0rem;
  .item {
    display: flex;
    padding: 1.2rem 1.6rem;
    box-shadow: .0rem .05rem .0rem #e3e3e3;
    align-items: center;
    .left {
      img {
        width: 3.0rem;
        height: 3.0rem;
      }
    }
    .content {
      flex: 1;
      padding-left: 1.2rem;
    }
    .row {
      display: flex;
      justify-content: space-between;
    }
    .hash {
      font-size: 1.3rem;
      line-height: 1.4rem;

      color: #000000;

      img {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
    .value {
      font-weight: 500;
      font-size: 1.5rem;
      line-height: 1.4rem;

      color: #f57627;
    }

    .type {
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 1.4rem;

      color: #969696;
    }
    .text {
      font-weight: 500;
      font-size: 1.3rem;
      line-height: 1.4rem;

      color: #000000;
    }
  }
`;